/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import { LogOut, Menu } from "lucide-react";

import routes from "routes.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "../../css/burgerAnimation.css";

function Header() {
  const location = useLocation();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [burgerAnimating, setBurgerAnimating] = useState(false);

  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    
    // Déclencher l'animation du burger
    setBurgerAnimating(true);
    
    // Après l'animation, ouvrir le sidebar
    setTimeout(() => {
      document.documentElement.classList.add("nav-open");
      setIsNavOpen(true);
      
      var node = document.createElement("div");
      node.id = "bodyClick";
      node.onclick = function () {
        closeSidebar();
      };
      document.body.appendChild(node);
    }, 300);
  };

  const closeSidebar = () => {
    document.documentElement.classList.remove("nav-open");
    setIsNavOpen(false);
    setBurgerAnimating(false);
    
    const bodyClick = document.getElementById("bodyClick");
    if (bodyClick) {
      bodyClick.parentElement.removeChild(bodyClick);
    }
  };

  // Exposer la fonction de fermeture globalement pour le Sidebar
  useEffect(() => {
    window.closeSidebarFromBurger = closeSidebar;
    return () => {
      delete window.closeSidebarFromBurger;
    };
  }, []);

  const getBrandText = () => {
    return (
      localStorage.getItem("firstName") + " " + localStorage.getItem("lastName")
    );
    /* if (!location.pathname.startsWith("/admin")) {
      return "Brand";
    }

    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand"; */
  };

  const history = useHistory();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("authToken");
    history.push("/login");
  };

  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          <Button
            variant="dark"
            className={`d-lg-none btn-fill d-flex justify-content-center align-items-center rounded-circle p-2 burger-btn ${burgerAnimating ? 'burger-fly-out' : ''} ${isNavOpen ? 'burger-hidden' : ''}`}
            onClick={mobileSidebarToggle}
            style={{ 
              width: '40px', 
              height: '40px',
              transition: 'all 0.3s ease-out'
            }}>
            <Menu size={20} color="#fff" />
          </Button>
          <Navbar.Brand
            href="#home"
            onClick={(e) => e.preventDefault()}
            className="mr-2">
            {getBrandText()}
          </Navbar.Brand>
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="mr-2">
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav mr-auto" navbar></Nav>
          <Nav className="ml-auto" navbar>
            <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#pablo"
                onClick={handleLogout}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <LogOut size={20} />
                <span className="no-icon">Se déconnecter</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
